import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';
import Email from '@crehana/icons/outline/Email';
import {
  colors,
  Dialog,
  DialogContent,
  InverseButton,
  PrimaryButton,
  // biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
} from '@crehana/ui';

import { useReportRoute } from './hooks';

const { baseLighter } = colors;

interface RoutesReportProps {
  isDark?: boolean;
  type: 'primary' | 'inverse';
}

const RoutesReport: FC<RoutesReportProps> = ({ isDark, type }) => {
  const { t } = useTranslation();

  const { sendReport, setReportDownloadDialog, reportDownloadDialog } =
    useReportRoute();

  const Button = type === 'primary' ? PrimaryButton : InverseButton;

  return (
    <>
      <Button
        className={type === 'primary' ? 'mr-0' : 'mr-12'}
        label={t('SEND_REPORT')}
        leftIcon={{ component: Email }}
        size="s"
        darkMode={isDark}
        onClick={sendReport}
      />
      <Dialog
        className="rounded-10"
        size="s"
        isDark={isDark}
        open={reportDownloadDialog}
        onDismiss={() => setReportDownloadDialog(false)}
      >
        <DialogContent className="flex flex-col items-center justify-center">
          <Email className="mb-16" color={baseLighter} size={64} />
          <h4 className="mb-16 font-h4 text-center">
            {t('ROUTES_REPORT_TITLE')}
          </h4>
          <p className="font-body4 text-center mb-16 mx-24 indent-8">
            {t('ROUTES_REPORT_TITLE_BODY')}
          </p>
          <div className="flex items-center">
            <PrimaryButton
              label={t('ROUTES_REPORT_TITLE_BUTTON')}
              className="my-12"
              onClick={() => setReportDownloadDialog(false)}
              darkMode={isDark}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RoutesReport;
